import React from "react";
import styles from "./index.module.scss";
import { PrismicNextImage } from "@prismicio/next";

const SingleCard = ({ term }) => {
  const points = term?.description?.[0]?.text?.split("\n");
  return (
    <div className={styles.loanCard}>
      <div className={styles.cardHeader}>
        <PrismicNextImage field={term?.icon} className={styles.cardIcon} />
        {/* <IconComponent className={styles.cardIcon} /> */}
        <h3 className={styles.cardTitle}>{term.title}</h3>
      </div>

      <div className={styles.cardContent}>
        {points?.map((value, idx) => (
          <p key={idx} className={styles.cardValue}>
            {value}
          </p>
        ))}
      </div>
    </div>
  );
};

export default SingleCard;
